import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { checkMot } from '../../ressources/functionJS/checkMot';
import FormDate from '../UI/FormDuration/FormDuration';
import PresetFavoriteProjects from './PresetFavoriteProjects/PresetFavoriteProjects';
import FormulaireSelectionMultipleTypeCapteur from '../UI/FormulaireSelectionMultipleTypeCapteur/FormulaireSelectionMultipleTypeCapteur';
import MultipleSelect from '../UI/MultipleSelect/MultipleSelect';
import ArborescenceConteneur from './ArborescenceConteneur/ArborescenceConteneur';
import S from './Maintenance.module.scss';
import ProjetsTauxCriticite from './ProjetsTauxCriticite/ProjetsTauxCriticite';
import { Project } from '../../types/types';
import {
  getFailureRatePerProject,
  getSensorFailureRatePerProject,
} from '../../services/api';
import Bouton from '../UI/Bouton/Bouton';
import * as requestType from '../../ressources/glossaires/glossaire_requetes';
import * as type_btn from '../../ressources/glossaires/glossaire_type_de_bouton';
import { VscRefresh } from 'react-icons/vsc';
import AttenteRequete from 'hoc/AttenteRequete/AttenteRequete';
import * as actions from 'services/actions';
const parProjet = 'parProjet';
const parCapteur = 'parCapteur';

interface MaintenanceProps {
  filtre_projects_list_id: number[];
}

type RootState = {
  authentifie: { filtre_projects_list_id: number[] };
};

const Maintenance = (props: MaintenanceProps) => {
  const [ongletSelectionne, setOngletSelectionne] = useState<string>(parProjet);
  const [types_id_list, setTypes_id_list] = useState<string[]>([]);
  const [criticity_id_list, setCriticity_id_list] = useState<any[]>(['null']);
  const [start_interval, setStart_interval] = useState<number>(
    Math.floor((new Date().getTime() - 24 * 60 * 60 * 1000) / 1000)
  );
  const [end_interval, setEnd_interval] = useState<number>(
    Math.floor(new Date().getTime() / 1000)
  );
  const [projectList, setProjectList] = useState<Project[] | undefined>(
    undefined
  );
  const [sensorList, setSensorList] = useState<any | undefined>(undefined);
  const filtre_projects_list_id = useSelector(
    (state: RootState) => state.authentifie.filtre_projects_list_id
  );
  const dispatch = useDispatch();

  const getData = useCallback(
    (typeId: string[], criticityId: string[]) => {
      try {
        dispatch(
          actions.debutAttente(
            requestType.recuperer_objet_projets_taux_de_pannes
          )
        );
        if (ongletSelectionne === parProjet) {
          const getFailureRate = async () => {
            const response = await getFailureRatePerProject(
              start_interval,
              end_interval,
              typeId.map((value) => parseInt(value.toString())),
              criticityId,
              filtre_projects_list_id
            );
            setProjectList(response.projects_list);
          };
          getFailureRate();
        } else {
          const getSensorFailureRate = async () => {
            const response = await getSensorFailureRatePerProject(
              start_interval,
              end_interval,
              typeId.map((value) => parseInt(value.toString())),
              criticityId,
              filtre_projects_list_id
            );
            setSensorList(response.sensors_list);
          };
          getSensorFailureRate();
        }

        dispatch(
          actions.finAttente(requestType.recuperer_objet_projets_taux_de_pannes)
        );
      } catch (error) {
        console.error(error);
      }
    },
    [ongletSelectionne, start_interval, end_interval, filtre_projects_list_id]
  );

  useEffect(() => {
    getData(types_id_list, criticity_id_list);
  }, [ongletSelectionne]);

  useEffect(() => {
    let sensorTypesIds = localStorage.getItem('maintenanceSensorTypesIdList');
    const sensorTypesIdList = sensorTypesIds
      ? sensorTypesIds.split(',').map((elem: string) => elem)
      : [];
    let criticityIds = localStorage.getItem('maintenanceCriticityIdList');
    const criticityIdList = criticityIds
      ? criticityIds.split(',').map((elem: string) => elem)
      : [];

    if (sensorTypesIdList) {
      setTypes_id_list(sensorTypesIdList);
    }
    if (criticityIdList) {
      setCriticity_id_list(criticityIdList);
    }
    getData(sensorTypesIdList, criticityIdList);
  }, [getData]);

  const gererCriticities_id = (criticity_id_list: string[]) => {
    localStorage.setItem(
      'maintenanceCriticityIdList',
      criticity_id_list.toString()
    );
    setCriticity_id_list(criticity_id_list);
  };
  const gererSensor_types_id = (types_id_list: string[]) => {
    localStorage.setItem(
      'maintenanceSensorTypesIdList',
      types_id_list.toString()
    );
    setTypes_id_list(types_id_list);
  };
  const gererTimePeriod = (startInterval?: number, endInterval?: number) => {
    startInterval && setStart_interval(startInterval);
    endInterval && setEnd_interval(endInterval);
  };
  const handleProjetCapteurDefaillant = () => {
    setOngletSelectionne(parCapteur);
  };

  let moduleOnglet;
  let toolsbar = [
    <PresetFavoriteProjects />,
    <FormDate setTime={gererTimePeriod} key={'FormDuration'} />,
    <MultipleSelect
      preconfigurerListe={criticity_id_list}
      label={checkMot('criticite')}
      namesList={[
        { label: '5', value: 5 },
        { label: '4', value: 4 },
        { label: '3', value: 3 },
        { label: '2', value: 2 },
        { label: '1', value: 1 },
        { label: 'null', value: null },
      ]}
      labelKey={'label'}
      valueKey={'value'}
      sx={{ m: 0, minWidth: 80, maxWidth: 120, marginLeft: 1 }}
      gererListeSelectionne={gererCriticities_id}
      key={'MultipleSelectCriticity'}
    />,
    <FormulaireSelectionMultipleTypeCapteur
      gererSensor_types_id={gererSensor_types_id}
      preconfigurerListe={types_id_list}
      key={'FormulaireSelectionMultipleTypeCapteur'}
    />,
    <Bouton
      key={'refresh-projets-list-maintenance-criticity'}
      overText={checkMot('refresh')}
      type={type_btn.outil}
      rond={true}
      cliquer={() => getData(types_id_list, criticity_id_list)}
    >
      <VscRefresh size={15} />
    </Bouton>,
  ];
  switch (ongletSelectionne) {
    case parProjet:
      moduleOnglet = (
        <ArborescenceConteneur
          toolsbar={toolsbar}
          start_interval={start_interval}
          end_interval={end_interval}
          criticity_id_list={criticity_id_list}
          types_id_list={types_id_list}
          filtre_projects_list_id={filtre_projects_list_id}
          projectList={projectList}
          handleProjetCapteurDefaillant={handleProjetCapteurDefaillant}
          afficherBarreDeRecherche={false}
        />
      );
      break;
    case parCapteur:
      moduleOnglet = (
        <ProjetsTauxCriticite
          toolsbar={toolsbar}
          start_interval={start_interval}
          end_interval={end_interval}
          criticity_id_list={criticity_id_list}
          types_id_list={types_id_list}
          sensorList={sensorList}
        />
      );
      break;
    default:
      moduleOnglet = (
        <div style={{ position: 'absolute', top: '50px', left: '15px' }}>
          {checkMot('selectionner_un_onglet')}
        </div>
      );
      break;
  }

  return (
    <>
      <AttenteRequete
        request_type={requestType.recuperer_objet_projets_taux_de_pannes}
        str={'Récupération des données de maintenance'}
      >
        <div className={[S.ConteneurVue].join(' ')}>
          <div className={S.barConteneur}>
            <div className={S.barOnglet}>
              <div
                title={checkMot('par_projet')}
                className={[
                  S.titreOnglet,
                  ongletSelectionne === parProjet
                    ? S.titreOngletSelectionne
                    : '',
                ].join(' ')}
                onClick={() => setOngletSelectionne(parProjet)}
              >
                {' '}
                {checkMot('par_projet')}{' '}
              </div>
              <div
                title={checkMot('par_capteur')}
                className={[
                  S.titreOnglet,
                  ongletSelectionne === parCapteur
                    ? S.titreOngletSelectionne
                    : '',
                ].join(' ')}
                onClick={() => setOngletSelectionne(parCapteur)}
              >
                {' '}
                {checkMot('par_capteur')}{' '}
              </div>
            </div>
          </div>
          {moduleOnglet}
        </div>
      </AttenteRequete>
    </>
  );
};

export default Maintenance;
